import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../services';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.less']
})
export class PasswordComponent implements OnInit {
  resetPassword!: FormGroup;
  recoverNoti = true;
  token: string = "";
  email:string = "";
  error = false;
  errorNoti:string;
  reasonPhraseCode = {
    '404': 'Mã xác minh hết hiệu lực',
  }

  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.resetPassword.controls.newpassword.value) {
      return { confirm: true, error: true };
    }
    return {};
  };

  updateConfirmValidator(): void {
    /** wait for refresh value */
    Promise.resolve().then(() => this.resetPassword.controls.password.updateValueAndValidity());
  }

  constructor(
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private readonly routerLinkActive: ActivatedRoute,
    public router:Router,
    private message: NzMessageService
  ) { }
  get recover() { return this.resetPassword.controls; }
  

  ngOnInit(): void {
    this.resetPassword = this.fb.group({
      token: [null, [Validators.required]],
      email: [null, [Validators.required]],
      newpassword: [null, [Validators.required]],
      password: [null, [Validators.required, this.confirmationValidator]]
    });
    this.getUrl();
  }

  getUrl(){
    this.routerLinkActive.paramMap.subscribe((params:any)=>{
      this.email = params.get('email');
      this.token = params.get('token'); 
    })
  }

  submitForm(): void {
    this.recoverNoti = true;
    for (const i in this.resetPassword.controls) {
      this.resetPassword.controls[i].markAsDirty();
      this.resetPassword.controls[i].updateValueAndValidity();
    }
    if(this.resetPassword.status == "VALID"){
      
      const value = {
        "email": this.recover.email.value,
        "token": this.recover.token.value,
        "newpassword": this.recover.password.value,
      }
      console.log('value', value);
      
      this.authenticationService.forgotPassword(value)
      .pipe(first())
      .subscribe(
        x => {
          console.log('x', x);          
          // this.message.info(this.reasonPhraseCode[404]);          
          this.recoverNoti = false;
          this.resetPassword.reset();
          // this.router.navigate(['/home']);
        },
        err => {   
          this.message.error(err);
          this.error = true;
          this.errorNoti = err;
          this.resetPassword.reset();
        },
        () => {
          this.message.success('Thay đổi mật khẩu thành công!');
        }
      );
      
    }
  }
}
